import { render } from "./FinancialsTab.vue?vue&type=template&id=e7a48920"
import script from "./FinancialsTab.vue?vue&type=script&lang=ts"
export * from "./FinancialsTab.vue?vue&type=script&lang=ts"
script.render = render

export default script